import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeApprover,
  changeAssignTo,
  changeAssignmentType,
  changeMonitors,
} from "../../features/assignWorkflowSlice";
import { AssignmentType, AssignedWorkflowStatus } from "../../constants/enum";
import { RootState } from "../../app/store";
import { isUndefined } from "lodash";
import { useAuthUser } from "react-auth-kit";
import Multiselect from "multiselect-react-dropdown";
import { CustomMultiSeclect } from "../custom-web-controls/CustomMultiSelect";
import {
  AssignedUserDto,
  ViewerDto,
} from "../../lib/data-transfer-object/assignWorkflow.dto";

interface AssignmentInformationProps {
  isReadOnly: boolean;
  data?: AssignmentInfoDto;
}

type AssignmentInfoDto = {
  assignTo: string; //string[];
  monitors: string; //string[];
  assignBy: string;
  approver: string;
  assignmentType: AssignmentType;
};

const initialValue = {
  assignTo: "",
  monitors: "",
  assignBy: "",
  approver: "",
  assignmentType: AssignmentType.INDIVIDUAL,
};

export const AssignmentInformation = (props: AssignmentInformationProps) => {
  const { isReadOnly, data } = props;
  const dispatch = useDispatch();
  const auth = useAuthUser();
  const [assignmentInfoValue, setAssignmentInfoValue] =
    useState<AssignmentInfoDto>(initialValue);

  const onApproverChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(changeApprover(event.target.value));
  };

  const onAssignToChange = (assignees: AssignedUserDto[]) => {
    dispatch(changeAssignTo(assignees));
  };

  const onMonitorsToChange = (monitors: ViewerDto[]) => {
    dispatch(changeMonitors(monitors));
  };

  const onAssignmentTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.value === "1") {
      setAssignmentInfoValue({
        ...assignmentInfoValue,
        assignmentType: AssignmentType.INDIVIDUAL,
      });
      dispatch(changeAssignmentType(AssignmentType.INDIVIDUAL));
    } else {
      setAssignmentInfoValue({
        ...assignmentInfoValue,
        assignmentType: AssignmentType.SHARED,
      });
      dispatch(changeAssignmentType(AssignmentType.SHARED));
    }
  };

  useEffect(() => {
    data && setAssignmentInfoValue(data);
  }, [data]);

  useEffect(() => {
    isUndefined(data) &&
      setAssignmentInfoValue({
        ...assignmentInfoValue,
        assignBy: auth()?.name,
      });
  }, [data]);

  return (
    <div id="assingment-information">
      <p className="card-title m-0 mb-2">Assignment Information</p>
      <div className="card bg-light border mb-5">
        <div className="card-body">
          <div className="row">
            <div className="col-12 col-sm-3">
              <p className="m-0">
                <b className="text-primary mr-2">Assign to:</b>
                <div className="form-group mb-2 row">
                  <div className="col-sm-12">
                    {!isReadOnly ? (
                      <>
                        <CustomMultiSeclect
                          options={[
                            {
                              name: "Test Buyer",
                              userId: "4A2BD70D-B9E1-4FD4-973D-8A38C1FCE835",
                            },
                          ]}
                          displayValue="name"
                          onRemove={onAssignToChange}
                          onSelect={onAssignToChange}
                        />
                      </>
                    ) : (
                      <input
                        type="text"
                        id="assignTo"
                        className="creators-hub-simulate-modal-input-text w-100 mt-4"
                        disabled
                        value={assignmentInfoValue.assignTo}
                      />
                    )}
                  </div>
                </div>
              </p>
            </div>
            <div className="col-12 col-sm-3">
              <p className="m-0">
                <b className="text-primary mr-2">Monitors:</b>
                <div className="form-group mb-2 row">
                  <div className="col-sm-12">
                    {!isReadOnly ? (
                      <>
                        <CustomMultiSeclect
                          options={[
                            {
                              name: "Test Seller",
                              userId: "08452C1D-34CA-4F3B-9B1B-24ADA878C4EA",
                            },
                          ]}
                          displayValue="name"
                          onRemove={onMonitorsToChange}
                          onSelect={onMonitorsToChange}
                        />
                      </>
                    ) : (
                      <input
                        type="text"
                        id="assignTo"
                        className="creators-hub-simulate-modal-input-text w-100 mt-4"
                        disabled
                        value={assignmentInfoValue.monitors}
                      />
                    )}
                  </div>
                </div>
              </p>
            </div>
            <div className="col-12 col-sm-3">
              <p className="m-0">
                <b className="text-primary mr-2">Assigned by:</b>
                <div className="form-group mb-2 row">
                  <div className="col-sm-12">
                    <input
                      name="assigned-by"
                      id="assigned-by"
                      value={assignmentInfoValue.assignBy}
                      className="creators-hub-simulate-modal-input-text w-100 mt-4"
                      disabled
                    />
                  </div>
                </div>
              </p>
            </div>
            <div className="col-12 col-sm-3">
              <p className="m-0">
                <b className="text-primary mr-2">Approver:</b>
                <div className="form-group mb-2 row">
                  <div className="col-sm-12">
                    {!isReadOnly ? (
                      <>
                        <input
                          list="assigned-bys"
                          name="assigned-by"
                          id="assigned-by"
                          className="creators-hub-simulate-modal-input-text w-100 mt-4"
                          onChange={(e) => onApproverChange(e)}
                        />
                        <datalist id="assigned-bys">
                          <option
                            key={"08452C1D-34CA-4F3B-9B1B-24ADA878C4EA"}
                            value="Test Seller"
                          />
                        </datalist>
                      </>
                    ) : (
                      <input
                        name="approver"
                        id="approver"
                        value={assignmentInfoValue.approver}
                        className="creators-hub-simulate-modal-input-text w-100 mt-4"
                        disabled
                      />
                    )}
                  </div>
                </div>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12">
              <div className="form-inline float-right">
                <b className="text-primary mr-3">Assignmnet Type:</b>
                <div className="form-check mr-5">
                  <label className="form-check-label">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="individual-task"
                      id="individual-task"
                      disabled={isReadOnly}
                      value={AssignmentType.INDIVIDUAL}
                      checked={
                        assignmentInfoValue.assignmentType ===
                        AssignmentType.INDIVIDUAL
                      }
                      onChange={(e) => onAssignmentTypeChange(e)}
                    />
                    Individual Task
                    <i className="input-helper"></i>
                  </label>
                </div>
                <div className="form-check">
                  <label className="form-check-label">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="shared-task"
                      id="shared-task"
                      disabled={isReadOnly}
                      value={AssignmentType.SHARED}
                      checked={
                        assignmentInfoValue.assignmentType ===
                        AssignmentType.SHARED
                      }
                      onChange={(e) => onAssignmentTypeChange(e)}
                    />
                    Shared Task
                    <i className="input-helper"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
